import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { Dashboard       } from 'src/app/beans/dashboard/dashboard';

@Injectable
({
  providedIn: 'root'
})

export class AppRouterHandler
{
    constructor
    (
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async getAppRouter( platform: string, protocol: string, base_url: string, code: string )
    {      
        try
        {
          const response = await this._request.appRouter().getAppRouter( platform, protocol, base_url, code ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response, null, false )
          }

          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

